export default "__VITE_ASSET__273cc798__"